import { getHttpClient } from "@/core/api";

export async function getTransportsSearch(queryParameters) {
  const response = await getHttpClient().get("v2/transports/search", {
    params: Object.assign({}, { page: 0, limit: 50 }, queryParameters),
  });

  return response.data;
}
